module.exports = __webpack_public_path__ + "img/at.04df62c7.svg";